<script lang="ts">
    import { appManager } from "../AppManager";
    import { _ } from "svelte-i18n";
    import { NavItem, NavLink } from "sveltestrap";
    import type { ScenarioManager } from "./ScenarioManager";
    import { get } from "svelte/store";
    import { Logo } from "@anyways-open/common-svgs";

    export let manager: ScenarioManager;
    const ready = manager.getReadyStore();
    const scenario = manager.getData();
    const otherScenarios = manager.getOtherScenarios();
    const viewStore = manager.getViewStore();

    let projectName = "";
    let projectUrl = "";
    let scenarioName = "";
    let scenarioId = undefined;
    let scenarios: { id: string; description: string }[] = [];

    const updateLinks = () => {
        const s = get(scenario);
        if (typeof s === "undefined") return;

        scenarioId = s.id;
        projectName = s.project.name;
        projectUrl = `${appManager.PublicUrl}project/${s.project.id}`;
        scenarioName = s.name;
    };

    $: {
        const s = get(scenario);
        if (typeof s !== "undefined" && scenarioId != s.id) {
            window.location.href = `${appManager.PublicUrl}scenario/${scenarioId}`;
        }
    }

    const updateScenarioList = () => {
        const s = get(otherScenarios);
        if (typeof s === "undefined") return;

        s.forEach((s) => {
            scenarios.push({
                id: s.scenario.id,
                description: `${s.scenario.name ?? ""}`,
            });
        });

        scenarios = scenarios;
    };

    if (typeof get(scenario) !== "undefined") {
        updateLinks();
    }

    if (typeof get(otherScenarios) !== "undefined") {
        updateScenarioList();
    }

    scenario.subscribe((s) => {
        updateLinks();
    });

    otherScenarios.subscribe(() => updateScenarioList());

    const onEdit = () => {
        viewStore.set("edit");
    };

    const onTest = () => {
        viewStore.set("test");
    }
</script>

<nav class="navbar navbar-expand-lg navbar-light p-1">
    <div class="container-fluid">
        <h4>
            <a
                class="icon footer-brand img-fluid pr-2"
                href={appManager.PublicUrl}>
                <Logo />
            </a>
        </h4>

        <div
            class="collapse navbar-collapse d-none d-lg-block"
            id="navbarCollapse">
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <i class="fe fe-x" />
            </button>

            <ol class="breadcrumb">
                <li
                    class="breadcrumb-item"
                    style="display: flex;align-items: center;" />
                <li
                    class="breadcrumb-item"
                    style="display: flex;align-items: center;">
                    <a class="text-gray-700" href={projectUrl}>
                        {@html projectName}
                    </a>
                </li>
                <li
                    class="breadcrumb-item"
                    style="display: flex;align-items: center;">
                    <select
                        bind:value={scenarioId}
                        class="form-select form-select-xs d-inline w-none"
                        id="scenario1">
                        {#each scenarios as o}
                            <option value={o.id}>{@html o.description}</option>
                        {/each}
                    </select>
                </li>
            </ol>

            <ul class="nav navbar-nav">
                <li class="dropdown ms-5">
                    <div class="btn-group mb-1">
                        <button
                            id="navbar-button-edit"
                            type="button"
                            class="navbar-btn btn-sm btn btn-primary {$ready
                                ? ''
                                : 'disabled'}"
                            on:click={() => onEdit()}
                            >{$_("impact.play.edit.title")}</button>
                    </div>
                </li>
                <li class="ms-3">
                    <button
                        id="navbar-button-test"
                        type="button"
                        class="navbar-btn btn btn-sm btn-primary {$ready
                            ? ''
                            : 'disabled'}"
                        on:click={() => onTest()}>
                        {$_("impact.play.test.title")}</button>
                </li>
            </ul>
        </div>

        <ul class="navbar-nav ms-auto">
            <NavItem>
                <NavLink href="https://docs.anyways.eu" target="_blank"
                    >{$_("general.documentation")}</NavLink>
            </NavItem>

            {#await appManager.isSignedIn()}
                <div class="btn-group" role="group" aria-label="Basic example">
                    <a
                        class="navbar-btn btn btn-sm btn-primary fs-sm"
                        href="https://www.anyways.eu/account"
                        data-smooth-scroll>
                        {$_("menu.account")}
                    </a>
                </div>
            {:catch error}
                <a
                    class="navbar-btn btn btn-sm btn-primary fs-sm"
                    href="/login"
                    data-smooth-scroll>
                    {$_("menu.signin")}
                </a>
            {/await}
        </ul>
    </div>
</nav>

<style>
    .w-none {
        width: unset;
    }
</style>
